"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme = styles_1.createMuiTheme({
    palette: {
        primary: {
            light: '#448c53',
            main: '#0e5e29',
            dark: '#003300',
            contrastText: '#fff',
        },
        secondary: {
            light: '#448d54',
            main: '#0e5f2a',
            dark: '#003400',
            contrastText: '#fff',
        },
    },
    overrides: {
        MuiButton: {
            text: {
                color: '#0E5F2A',
                height: 48,
                padding: '0 30px',
            },
        },
        MuiContainer: {
            root: {
                marginTop: '20px',
                marginBottom: '20px'
            }
        },
        MuiCardMedia: {
            root: {
                backgroundSize: 'contain',
                marginTop: '20px',
                marginBottom: '20px'
            }
        },
        MuiDivider: {
            root: {
                height: '5px',
                backgroundColor: '#0E5F2A'
            }
        },
        // MuiPaper :{
        //   rounded : {
        //     borderRadius:'25px'
        //   }
        // },
        MuiAppBar: {
            root: {
                borderTopStyle: 'solid',
                borderTopColor: '#0E5F2A',
                borderWidth: 10,
                backgroundColor: '#FFFFFF',
                boxShadow: 'none'
            },
            colorPrimary: {
                backgroundColor: '#FFFFFF'
            }
        }
    },
});
exports.default = theme;
